// Finance gate, same mechanism as config/notesAccess.js and ownerAccess.js: an
// explicit UPN allowlist checked against account.username, lowercased.
//
// Finance is Marc and Angela only: bank balances, runway, net worth, and the
// Trust account, which holds client funds. Nobody else in the family tenant
// sees the nav link, the More menu entry, or the route. The gate is all or
// nothing — whoever is on the list sees every tab, FIG and Trust included.
//
// This list decides what the APP shows. Whether an account can actually read
// the Finance_* lists is SharePoint's call (site and list permissions), and is
// set there, not here.
//
// The list is SEPARATE from the Notes and owner allowlists, for the reason
// ownerAccess.js gives: granting someone Notes or Contacts must never silently
// grant them the family's finances.
export const FINANCE_ACCESS_ALLOWLIST = [
  'marc@defineholy.com',
  'marc@myfiginsurance.com',
  'angela@defineholy.com',
];

export function userHasFinanceAccess(account) {
  if (!account || !account.username) return false;
  return FINANCE_ACCESS_ALLOWLIST.includes(account.username.toLowerCase());
}
